import React, { useState } from "react"

import Link from "./link"
import {
  NavContainer,
  NavWrapper,
  Logo,
  Navbar,
  Navs,
  Nav,
  Burger,
  BurgerOpen,
  Triangle,
  Slash,
  Composer,
} from "../styles"

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)
  const close = () => setIsOpen(false)

  return (
    <NavContainer row>
      <NavWrapper row justifyBetween alignCenter>
        <Link to="/" onClick={close}>
          <Logo>
            <Triangle />
            Ioannis Angelakis
          </Logo>
          <Composer>composer</Composer>
        </Link>
        <Burger onClick={toggle} />
      </NavWrapper>
      <Navbar showNav={isOpen} alignStart>
        <BurgerOpen onClick={toggle} />
        <Navs>
          <Nav to="/" onClick={close}>
            HOME
          </Nav>
          <Slash>/</Slash>
          <Nav to="/about/" onClick={close}>
            ABOUT
          </Nav>
          <Slash>/</Slash>
          <Nav to="/works/" onClick={close}>
            WORKS
          </Nav>
          <Slash>/</Slash>
          <Nav to="/texts/" onClick={close}>
            TEXTS
          </Nav>
          <Slash>/</Slash>
          <Nav to="/news/" onClick={close}>
            NEWS
          </Nav>
          <Slash>/</Slash>
          <Nav to="/contact/" onClick={close}>
            CONTACT
          </Nav>
        </Navs>
      </Navbar>
    </NavContainer>
  )
}

export default Header
